import Tag from "common/form/entities/Tag";
import styled from "styled-components";

const Padding = styled.div`
    padding-top:5px;
    padding-bottom:5px;
`;

//this function assumes tags are sorted based with tagset.name,tag.name and return tagset name for first tag from tagset
//could not use this function in topic entity as it has jsx so extracted it here
const showTagSetOnFirstTag = (tag:Tag,tags:Tag[])=>{
    let filteredTags = tags.filter((t)=>t.tagSet.name == tag.tagSet.name);
    if(filteredTags && filteredTags.length && filteredTags.indexOf(tag) == 0)
        return <Padding>{tag.tagSet.name}</Padding>;
    return <span />;
}
export default showTagSetOnFirstTag;



// WEBPACK FOOTER //
// ./src/panels/forum/ForumTagUtils.tsx